module.exports = __webpack_public_path__ + "media/images/browse_classes_bg-dd0fcaf1835fa95121ef032909b30929.png";